/** Protein / carbs / fat against target. Every bar is labelled in text, never
 *  colour alone (fat's aqua is under 3:1 on the light surface). */

export function MacroBars({ values, targets }: {
  values: { protein_g: number; carbs_g: number; fat_g: number }
  targets: { protein_g: number; carbs_g: number; fat_g: number } | null
}) {
  const rows = [
    { key: 'protein_g', label: 'Protein', color: 'var(--protein)' },
    { key: 'carbs_g', label: 'Carbs', color: 'var(--carbs)' },
    { key: 'fat_g', label: 'Fat', color: 'var(--fat)' },
  ] as const
  return (
    <div className="stack" style={{ flex: 1, minWidth: 0 }}>
      {rows.map((r) => {
        const v = values[r.key], t = targets?.[r.key] ?? 0
        const pct = t > 0 ? Math.min(100, (v / t) * 100) : 0
        return (
          <div key={r.key} style={{ marginTop: '.55rem' }}>
            <div className="row small" style={{ gap: '.4rem' }}>
              <span style={{ fontWeight: 600 }}>{r.label}</span>
              <span className="num muted">{Math.round(v)}{t ? ` / ${Math.round(t)}` : ''} g</span>
            </div>
            <div className="bar-track" style={{ marginTop: '.2rem' }}>
              <div className="bar-fill" style={{ width: `${pct}%`, background: r.color }} />
            </div>
          </div>
        )
      })}
    </div>
  )
}
